import { StorefrontIcon as PhosphorStorefrontIcon } from "@phosphor-icons/react/dist/ssr/Storefront";

import { createAppIcon } from "@/components/createAppIcon";

export const SellIcon = /* @__PURE__ */ createAppIcon(PhosphorStorefrontIcon);
export const StoreIcon = /* @__PURE__ */ createAppIcon(PhosphorStorefrontIcon);
